<template>
  <b-container fluid id="main-container">
    <b-row>
      <b-col xs=12 class='no-padding'>
        <div class="instruction-section">
          <p v-if="$store.getters.language === 'SLO'" class='instruction-section-title'>{{model_name_slo}}</p>
          <p v-else class='instruction-section-title'>{{model_name}}</p>
          <p v-if="$store.getters.language === 'SLO'" class='instruction-section-text'> Vpiši tekst in klikni na gumb Določi</p>
          <p v-else class='instruction-section-text'> Type or paste a text into the text area and click on the classify button</p>
        </div>
      </b-col>
    </b-row>
    <b-form-group class="input-group-classification" label="">
      <b-form-textarea
        v-if="$store.getters.language === 'SLO'"
        type="textarea"
        v-model="text"
        rows="4"
        max-rows="8"
        placeholder="Vpiši tekst"     
      ></b-form-textarea>
      <b-form-textarea
        v-else
        type="textarea"
        v-model="text"
        rows="4"
        max-rows="8"
        placeholder="Enter text"     
      ></b-form-textarea>
    </b-form-group>
    <div class="center-button">
      <b-button v-if="$store.getters.language === 'SLO'" pill v-on:click="classify" id="button-classify" type="button" variant="dark">Določi</b-button> 
      <b-button v-else pill v-on:click="classify" id="button-classify" type="button" variant="dark">Classify</b-button> 
    </div>
    <div class="error"><p>{{error}}</p></div>
    <div class="prediction"><p>{{prediction}}</p></div> 
  </b-container>
</template>

<script>
export default {
  name: "DocumentClassification",
  components: {},
  data() {
    return {
      text: '',
      model_name: '',
      model_name_slo: '',
      prediction: '',
      error: '',
    };
  },
  mounted() {
    if (typeof this.$route.params['model_id'] !== 'undefined') {
      this.model_id = this.$route.params['model_id'];
      this.model_name = this.$route.params['model_name'];
      this.model_name_slo = this.$route.params['model_name_slo'];
      this.$store.dispatch('save_model_id', this.model_id);
      this.$store.dispatch('save_model_name', this.model_name)
      this.$store.dispatch('save_model_name_slo', this.model_name_slo)
    }
    else {
      this.model_id = this.$store.getters.model_id
      this.model_name = this.$store.getters.model_name
    }
  },
  methods: {
    classify() {
      if (this.text.length > 0) { 
        this.error = ''
        this.prediction = ''
        this.$http({url: this.$hostname + '/api/model/' + this.model_id + '/get', data: {'text': this.text}, method: 'POST' })
        .then(response => { 
          this.prediction = response.data.model_reponse['decision']
          console.log(this.prediction)
        })
        .catch(error => {
          console.error(error);
        });
      }
      else {
        if (this.$store.getters.language === 'SLO') {
          this.error = "Vnesi tekst!"
        }
        else {
          this.error = "Write or copy paste a text!"
        }
        this.prediction = ''
      }
    }
  },
}
</script>

<style lang="scss">
thead, tbody, tfoot, tr, td, th {
  text-align: left;
  width: 100px;
  vertical-align: middle;
  cursor: pointer;
}
.search-input{
  float: left;
  width: 70%;
}
.search-button{
  float: left;
  width: 27%;
  margin-left: 3% !important;
}
.instruction-section-title {
  text-align: center;
  margin-top: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  color: #fff;
}
.instruction-section {
  padding: 20px;
  display: block;
  background-color: #4F6675;
  margin-bottom: 30px;
}

.instruction-section-text {
  text-align: center;
  margin: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 300;
}

#button-classify {
  background-color: #4F6675;
  border: #4F6675;
}

.input-group-classification {
  margin-left:25%;
  margin-bottom: 20px;
  width: 50%;
  margin-top: 50px;
  font-weight:bold;
}

.error {
  text-align: center;
  color: red;
  padding-top: 20px;
}

.prediction {
  text-align: center;
  color: #4F6675;
  padding-top: 20px;
  font-size: 20px;
  font-weight: 500;
  text-transform: uppercase;
  min-height: 80px;
}

</style>